// extracted by mini-css-extract-plugin
module.exports = {"frc":"FriendlyCaptchaChallenge_frc__sXXJ7"};